import React, {
  Component
} from "react";
import {
  connect
} from "react-redux";
import {Group} from "react-konva";
import {InchUtility} from "../../../lib/pipe-dataset";
import ManifoldTeeComponent from "./manifold-tee-component";
import ManifoldCornerComponent from "./manifold-corner-component";

import {
  PIPE_MANIFOLD_TEE_TYPE,
  PIPE_ELEMENT_TYPE_SINGLE_TEE,
  PIPE_ELEMENT_TYPE_DOUBLE_TEE,
  PIPE_ELEMENT_TYPE_TRIPLE_TEE,
  PIPE_ELEMENT_TYPE_BEND,
  PIPE_BED_LOWER_MANIFOLD,
  PIPE_FLOW_ARROW_ORIENTATION, PIPE_FLOW_BASIN_POSITION
} from "../../../lib/types";
import {
  doesPipeFlowDirectionStartOnTop,
  doesPipeFlowDirectionEndOnTop,
  doesPipeFlowDirectionStartLeft,
  doesPipeFlowDirectionStartRight,
  doesPipeFlowDirectionEndLeft,
  doesPipeFlowDirectionEndRight,
  doesPipeFlowDirectionEndOnBottom,
  doesPipeFlowDirectionStartOnBottom
} from "../../../actions/pipe-bed-actions";

class PipeBottomRowComponent extends Component {
  get arrowOrientation() {
    const {
      doesPipeFlowDirectionStartOnTop,
      doesPipeFlowDirectionStartLeft,
      doesPipeFlowDirectionEndRight,
      doesPipeFlowDirectionEndOnBottom,
      doesPipeFlowDirectionStartOnBottom
    } = this.props;

    const result = {
      vertical: doesPipeFlowDirectionStartOnTop() ? PIPE_FLOW_ARROW_ORIENTATION.UP : PIPE_FLOW_ARROW_ORIENTATION.DOWN,
      horizontal: (
        (doesPipeFlowDirectionStartOnBottom() && doesPipeFlowDirectionStartLeft()) ||
        (doesPipeFlowDirectionEndOnBottom() && doesPipeFlowDirectionEndRight())) ? PIPE_FLOW_ARROW_ORIENTATION.LEFT : PIPE_FLOW_ARROW_ORIENTATION.RIGHT
    };
    //console.log("- Bottom Row Arrow Orientation : ", result);
    return result;
  }

  getYPosition() {
    return this.props.bedLength - ((this.props.perimeterOffset.px * 2) + this.props.manifoldRowHeight)
  }

  get cornerWidth() {
    return this.props.rowSpacing.px - ((this.props.rowSpacing.px / 2) - (this.props.pipeOD / 2))
  }

  renderManifolds = () => {
    let componentIndex = 1;
    let cumulativeOffset = this.props.rowSpacing.px;

    const singleManifolds = [...new Array(this.props.numberOfManifoldTeesSingles)].map((n, i) => {
      let id = {
        section: PIPE_BED_LOWER_MANIFOLD,
        index: componentIndex++,
        type: PIPE_ELEMENT_TYPE_SINGLE_TEE
      };
      const x = ((i * (this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.SINGLE)) + cumulativeOffset) + (this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.SINGLE);
      return <ManifoldTeeComponent arrowOrientation={this.arrowOrientation} key={i} id={id} rotation={180}
                                   manifoldType={PIPE_MANIFOLD_TEE_TYPE.SINGLE} x={x}
                                   y={this.props.manifoldRowHeight}/>;
    });
    cumulativeOffset = cumulativeOffset + (this.props.numberOfManifoldTeesSingles * (this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.SINGLE));

    const doubleManifolds = [...new Array(this.props.numberOfManifoldTeesDoubles)].map((n, i) => {
      let id = {
        section: PIPE_BED_LOWER_MANIFOLD,
        index: componentIndex++,
        type: PIPE_ELEMENT_TYPE_DOUBLE_TEE
      };
      const x = ((i * (this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.DOUBLE)) + cumulativeOffset) + (this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.DOUBLE);
      return <ManifoldTeeComponent arrowOrientation={this.arrowOrientation} key={i} id={id} rotation={180}
                                   manifoldType={PIPE_MANIFOLD_TEE_TYPE.DOUBLE} x={x}
                                   y={this.props.manifoldRowHeight}/>;
    });
    cumulativeOffset = cumulativeOffset + (this.props.numberOfManifoldTeesDoubles * (this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.DOUBLE));

    const tripleManifolds = [...new Array(this.props.numberOfManifoldTeesTriples)].map((n, i) => {
      let id = {
        section: PIPE_BED_LOWER_MANIFOLD,
        index: componentIndex++,
        type: PIPE_ELEMENT_TYPE_TRIPLE_TEE
      };
      const x = ((i * this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.TRIPLE) + cumulativeOffset) + (this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.TRIPLE);
      return <ManifoldTeeComponent arrowOrientation={this.arrowOrientation} key={i} id={id} rotation={180}
                                   manifoldType={PIPE_MANIFOLD_TEE_TYPE.TRIPLE} x={x}
                                   y={this.props.manifoldRowHeight}/>;
    });

    let leftCornerId = {
      section: PIPE_BED_LOWER_MANIFOLD,
      index: 0,
      type: PIPE_ELEMENT_TYPE_BEND
    };
    let rightCornerId = {
      section: PIPE_BED_LOWER_MANIFOLD,
      index: componentIndex,
      type: PIPE_ELEMENT_TYPE_BEND
    };

    if (this.props.numberOfPipeRows <= 0) {
      //if no rows then avoid placing corner manifolds
      return []
    }

    return (
      <React.Fragment>
        <ManifoldCornerComponent
          x={0}
          scaleY={-1}
          id={leftCornerId}
          accessoryScaleX={-1}
          accessoryScaleY={-1}
          accessoryRotation={90}
          cornerWidth={this.cornerWidth}
          y={this.props.manifoldRowHeight}
          arrowOrientation={this.arrowOrientation}
          basinPosition={PIPE_FLOW_BASIN_POSITION.BOTTOM_LEFT}
        />
        {singleManifolds}
        {doubleManifolds}
        {tripleManifolds}
        <ManifoldCornerComponent
          scaleY={-1}
          scaleX={-1}
          id={rightCornerId}
          accessoryScaleX={-1}
          accessoryScaleY={-1}
          accessoryRotation={0}
          cornerWidth={this.cornerWidth}
          arrowOrientation={this.arrowOrientation}
          basinPosition={PIPE_FLOW_BASIN_POSITION.BOTTOM_RIGHT}
          x={this.props.bedWidth} y={this.props.manifoldRowHeight}
        />
      </React.Fragment>);
  };

  render() {
    return (
      <Group
        x={0}
        y={this.getYPosition()}
      >
        {this.renderManifolds()}
      </Group>
    );
  }
}

const mapStateToProps = state => {
  return {
    bedLength: state.pipeBed.dimensions.length.px,
    numberOfPipeRows: state.pipeBed.numberOfPipeRows,
    bedWidth: state.pipeBed.pipeBedDimensions.width.px,
    rowSpacing: new InchUtility(state.pipeBed.rowSpacing),
    pipeFlowDirection: state.pipeGlobals.pipeFlowDirection,
    pipeOD: state.pipeGlobals.pipeNominalDiameter.pipeOD.px,
    perimeterOffset: new InchUtility(state.pipeGlobals.pipePerimeterOffset),
    numberOfManifoldTeesTriples: state.pipeBed.manifoldTeeDistribution.triples,
    numberOfManifoldTeesDoubles: state.pipeBed.manifoldTeeDistribution.doubles,
    numberOfManifoldTeesSingles: state.pipeBed.manifoldTeeDistribution.singles,
    manifoldRowHeight: state.pipeGlobals.pipeNominalDiameter.horizontalRowHeight.px,
  };
};

const mapDispatchToProps = {
  doesPipeFlowDirectionEndLeft,
  doesPipeFlowDirectionEndOnTop,
  doesPipeFlowDirectionEndRight,
  doesPipeFlowDirectionStartLeft,
  doesPipeFlowDirectionStartRight,
  doesPipeFlowDirectionStartOnTop,
  doesPipeFlowDirectionEndOnBottom,
  doesPipeFlowDirectionStartOnBottom
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PipeBottomRowComponent);



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/pipe-bottom-row-component.js